const AlertType = {
    schedule: 'Schedule',
    performance: 'Performance'
}

export default AlertType;